module.exports = __webpack_public_path__ + "static/media/c-grammar.1ab00563.svg";